import { render, staticRenderFns } from "./mpesa.vue?vue&type=template&id=4cd8e435"
import script from "./mpesa.vue?vue&type=script&lang=js"
export * from "./mpesa.vue?vue&type=script&lang=js"
import style0 from "./mpesa.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/mpesa.vue
// module id = MXgI
// module chunks = 0